import classNames from "classnames";
import {FiArrowLeft, FiArrowRight} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import {ANALYZER} from "@/lib/featureFlags.ts";

import styles from "./ButtonRow.module.scss";

interface ButtonRowProps {
  onSubmit: (back?: boolean) => void;
  stepsCount: number;
  activeStepNr: number;
  isNextDisabled?: boolean;
}

export const ButtonRow = ({onSubmit, stepsCount, activeStepNr, isNextDisabled}: ButtonRowProps) => {
  const {userHasFeature} = useCurrentUserContext();
  const isFirstStep = activeStepNr === 0;
  const isLastStep = activeStepNr === stepsCount - 1;
  const showDoneLabel = isLastStep && !userHasFeature(ANALYZER);
  const nextLabel = isLastStep ? "Set Up Your First Checks" : "Continue";

  return (
    <div className={`${styles.buttonRow} ` + (isLastStep ? `${styles.lastStep}` : "")}>
      {!isFirstStep && (
        <Button variant="secondary" size="large" onClick={() => onSubmit(true)}>
          <Icon icon={FiArrowLeft} /> Back
        </Button>
      )}
      <Button
        size="large"
        disabled={isNextDisabled}
        onClick={() => onSubmit()}
        className={classNames({[styles.fullWidth]: isFirstStep})}
      >
        {showDoneLabel ? (
          <span className="text-nowrap">Done – Start Using Uptime.com</span>
        ) : (
          <>
            {nextLabel} <Icon icon={FiArrowRight} />
          </>
        )}
      </Button>
    </div>
  );
};
